import { render, staticRenderFns } from "./FingerReader.vue?vue&type=template&id=0a17fd21&scoped=true"
import script from "./FingerReader.vue?vue&type=script&lang=js"
export * from "./FingerReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a17fd21",
  null
  
)

export default component.exports